import React from "react";
import {Link} from "react-router-dom"

interface Props {
    title: string,
    url: string,
    children?: React.ReactNode;
}

const PanelSidebarSubMenuItem: React.FC<Props> = props => {
    return(
        <div>
            <Link to={props.url} className="text-secondaryLight mr-5 flex items-center space-x-2 space-x-reverse py-2 pr-6 hover:text-secondary">
                <div className="w-2 h-1 rounded-full bg-secondary mt-1" />
                <div className="text-md">{props.title}</div>
            </Link>
        </div>
    )
}

export default PanelSidebarSubMenuItem